import React, { useEffect } from "react";
import "./App.css";
import { ClinicProvider, useClinic } from "./context/ClinicContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Appointments from "./components/Appointments";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function AppContent() {
  const { clinicInfo } = useClinic();

  useEffect(() => {
    document.title = clinicInfo.name || "Dental Clinic";
  }, [clinicInfo.name]);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Testimonials />
        <FAQ />
        <Appointments />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <ClinicProvider>
      <AppContent />
    </ClinicProvider>
  );
}

export default App;
